import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
/**
 * 获取任务中心列表
 */
export function taskCenterListApi({ type, page = 1, limit = 10, status }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task-center/list`,
        method: 'GET',
        params: {
            type,
            page,
            limit,
            status,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 删除任务
 *
 * @param {String} task_id
 * @returns Promise
 */
export function deleteTaskApi({ task_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task-center`,
        method: 'DELETE',
        data: [task_id],
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 清空任务
 */
export function deleteAllTaskApi() {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task-center/all`,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 取消任务
 * @returns
 */
export function cancelTaskApi({ task_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task-center`,
        method: 'PUT',
        data: [task_id],
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/**
 * 撤回任务
 * @returns
 */
export function undoTaskApi({ task_id, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task-center/task/undo`,
        method: 'POST',
        data: { task_id },
        transformCode: true,
    }).then(({ data, }) => {
        return data.data || {};
    });
}
/**
 * 撤回任务
 * @returns
 */
export function getUndoTaskStatusByIdApi({ task_id, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/task-center/task/undo-status`,
        method: 'POST',
        data: { task_id },
        transformCode: true,
    }).then(({ data, }) => {
        return data.data || {};
    });
}
